import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import experienceApp from './reducers'
import App from './App';
import "./i18n";
import * as serviceWorker from './serviceWorker';
import history from "./history";

import { isLocalhost } from './utils/globals';

let store = createStore(experienceApp, applyMiddleware(thunk, promise));

history.listen((location) => {
  const page = location.pathname + location.search;

  // window.fbq('track', 'PageView',{
  //   'page_title': document.title,
  //   'page_path': page
  // });
  window.gtag('config', 'UA-171846092-3', {
    'page_title': document.title,
    'page_path': page
  });
});

if (!isLocalhost())
  Sentry.init({dsn: "https://7ce11089998d44afb164ec5d64eda49e@o427254.ingest.sentry.io/5371037"});

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App history={history} />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
